export const licensesPage = () =>
  import("./LicensesPage").then((m) => ({ Component: m.LicensesPage }));
